const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: "top", labels: { font: { size: 12 } } },
    title: { display: true, font: { size: 14 } },
    tooltip: {
      bodyFont: { size: 12 },
      callbacks: {
        label: (context) => {
          const isCurrency =
            context.dataset.label.includes("Revenue") ||
            context.dataset.label.includes("ADR");
          const value = Number(context.raw).toLocaleString(
            "vi-VN",
            isCurrency ? { style: "currency", currency: "VND" } : undefined
          );
          return `${context.dataset.label}: ${value}`;
        },
      },
    },
    datalabels: {
      anchor: "end",
      align: "top",
      font: { size: 12 },
      formatter: (value, context) => {
        const isCurrency =
          context.dataset.label.includes("Revenue") ||
          context.dataset.label.includes("ADR");
        return Number(value).toLocaleString(
          "vi-VN",
          isCurrency ? { style: "currency", currency: "VND" } : undefined
        );
      },
    },
  },
  scales: {
    x: { ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 45 } },
    y: {
      beginAtZero: true,
      ticks: {
        font: { size: 10 },
        callback: function (value) {
          const chart = this.chart;
          const isCurrency =
            chart.data.datasets[0].label.includes("Revenue") ||
            chart.data.datasets[0].label.includes("ADR");
          return Number(value).toLocaleString(
            "vi-VN",
            isCurrency ? { style: "currency", currency: "VND" } : undefined
          );
        },
      },
    },
  },
};

const horizontalChartOptions = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: "top", labels: { font: { size: 12 } } },
    title: { display: true, font: { size: 14 } },
    tooltip: {
      bodyFont: { size: 12 },
      callbacks: {
        label: (context) =>
          `${context.dataset.label}: ${Number(context.raw).toLocaleString(
            "vi-VN"
          )}`,
      },
    },
    datalabels: { display: false },
  },
  scales: {
    x: {
      beginAtZero: true,
      ticks: {
        font: { size: 10 },
        callback: (value) => Number(value).toLocaleString("vi-VN"),
      },
      grid: { display: true, drawBorder: true },
    },
    y: {
      ticks: { font: { size: 10 } },
      grid: { display: false, drawBorder: true },
    },
  },
};

const doughnutChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: {
      display: true,
      font: { size: 12 },
      padding: { top: 5, bottom: 10 },
    },
    tooltip: {
      bodyFont: { size: 10 },
      callbacks: {
        label: (context) => `${context.label}: ${context.raw} bookings`,
        title: (tooltipItems) => tooltipItems[0].label || "",
      },
    },
    datalabels: {
      color: "#fff",
      font: { size: 10, weight: "bold" },
      formatter: (value, context) => {
        const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
        const percentage = ((value / total) * 100).toFixed(1);
        return percentage > 5 ? `${percentage}%` : "";
      },
    },
  },
  cutout: "60%",
};

export { chartOptions, horizontalChartOptions, doughnutChartOptions };
